/**
 * @file useSectionIssueGroups.ts
 * @description Группы панели секции, в которых есть замечания проверки
 * (phase19.16, SB122; ревью партии SB122): ✕ в заголовке свёрнутой группы.
 * Замечания — из формы секции (`useSectionForm().issuePaths`), группа по
 * пути — реестром `lib/site-builder/issue-groups.ts`.
 */

import { useMemo } from "react";

import { useSectionForm } from "../../components/site-builder/section/section-form-context";
import { groupsWithIssues, type IssueGroupRule } from "../../lib/site-builder/issue-groups";

/**
 * @param rules реестр групп панели
 * @param base путь элемента для панели элемента (`columns.items.0.elements.2`)
 */
export function useSectionIssueGroups<G extends string>(rules: readonly IssueGroupRule<G>[], base = ""): ReadonlySet<G> {
  const { issuePaths } = useSectionForm();
  return useMemo(() => groupsWithIssues(issuePaths, rules, base), [issuePaths, rules, base]);
}
